import { Table$RowPressEvent } from "sap/ui/mdc/Table";
import BaseController from "./BaseController";
import Log from "sap/base/Log";
import { SearchField$SearchEvent } from "sap/m/SearchField";
import JSONModel from "sap/ui/model/json/JSONModel";
import { EnvironmentService } from "../service/Environment.service";
import { Route$PatternMatchedEvent } from "sap/ui/core/routing/Route";
import { CheckBox$SelectEvent } from "sap/m/CheckBox";
import { ErrorHandler } from "../service/ErrorHandler.service";
/**
 * @namespace com.unitrade.crm.controller
 */
export default class CustomerList extends BaseController {
  private static CUSTUMER_FIND_ENPOINT: string = "/kunde/find";

  private stateModel = new JSONModel({ busy: false, filterByKundenbetreuer: true, search: "" });
  private customersModel = new JSONModel();

  public async onInit(): Promise<void> {
    try {
      this.getView().setModel(this.stateModel);
      this.getView().setModel(this.customersModel, "customers");
      const username = localStorage.getItem("auth_username");
      this.stateModel.setProperty("/username", username);

      const result = await $.get(`${EnvironmentService.getBaseUrl()}/user/username`, { username: username });
      this.stateModel.setProperty("/username", result.name);
      const oOwnerComponent = this.getOwnerComponent();
      const oRouter = oOwnerComponent.getRouter();
      await this.loadCustomers();
      oRouter.getRoute("customers").attachPatternMatched(this._onPatternMatch, this);
    } catch (ex: any) {
      ErrorHandler.handleError(ex, { message: "Fehler beim Initialisieren der Kundenliste", onRetry: this.onInit.bind(this) });
    }
  }

  private _onPatternMatch = async (oEvent: Route$PatternMatchedEvent) => {
    await this.loadCustomers();
  };
  public override async getTitle(): Promise<string> {
    return await this.getTranslatedString("customers");
  }

  public onFilterByKundenbetreuerSelect = async (oEvent: CheckBox$SelectEvent) => {
    await this.loadCustomers();
  };

  private loadCustomers = async (searchValue: string = null) => {
    const filterByKundenbetreuer = this.stateModel.getProperty("/filterByKundenbetreuer");
    this.stateModel.setProperty("/busy", true);
    const queryUrl = `${EnvironmentService.getBaseUrl()}${CustomerList.CUSTUMER_FIND_ENPOINT}`;
    const parameters: { [key: string]: any } = {};
    if (searchValue) {
      parameters["search"] = searchValue;
    }
    if (filterByKundenbetreuer) {
      parameters["filterByKundenbetreuer"] = true;
    }

    try {
      await this.customersModel.loadData(queryUrl, parameters);
    } catch (ex: any) {
      ErrorHandler.handleError(ex, { title: "Fehler beim Laden der Kundenliste" });
    } finally {
      this.stateModel.setProperty("/busy", false);
    }
  };

  onPress(oEvent: Table$RowPressEvent): void {
    const oItem = oEvent.getSource();
    const oBindingContext = oItem.getBindingContext("customers");
    const oModel = oBindingContext.getModel();
    const id = oModel.getProperty("id", oBindingContext) as number;
    const lfd = oModel.getProperty("lfd", oBindingContext) as number;
    Log.info(`Navigating to customer details ${id}/${lfd}`, null, this.getView().getControllerName());
    this.getOwnerComponent().getRouter().navTo("customersDetails", { idPath: id, lfdPath: lfd });
  }

  filterGlobally(oEvent: SearchField$SearchEvent) {
    const sQuery = oEvent.getParameter("query");
    this.stateModel.setProperty("/search", sQuery);
    this.loadCustomers(sQuery);
  }
}
